mutation SignIn($input: SignInInput!) {
  signIn(input: $input) {
    token
  }
}
